var tl = new TimelineMax({paused: true}),
	winH,
	cover = true,
	animPage = [],
	animIntro,
	animMain,
	animMainMobile,
	mobileAdjust,
	currentPage,
	iconTop,
	fasSound = document.getElementById("fasSound"),
	auzSound = document.getElementById("auzSound");

var pages = [{},{
	icon: 'iconfont-vaz',
	title: 'văz',
	text: 'Culoarea distinctă, ca de opal, a Staropramen Unfiltered îi dă un aspect special, care îți atrage imediat atenția. Alegem cu grijă ingredientele pentru a crea un gust potrivit stilului tău de viață. '
},{
	icon: 'iconfont-auz',
	title: 'auz',
	text: 'Sunetul fiecărei sticle de Staropramen Unfiltered deschise este unul memorabil, unul care parcă anunță mixul perfect de malț din grâu, hamei selecționat și un dram de coriandru ce îți va răsfăța simțurile.'
},{
	icon: 'iconfont-gust',
	title: 'gust',
	text: 'Staropramen Unfiltered este o bere făcută din malț de grâu, cel mai fin hamei și un pic de coriandru, elementul surpriză adăugat pentru un plus de savoare. Toate acestea îi oferă un gust unic și rafinat, dar și o aromă bogată, pentru ca tu să te bucuri de o bere bună împreună cu prietenii.'
},{
	icon: 'iconfont-miros',
	title: 'miros',
	text: 'Mirosul Staropramen Unfiltered este unul aparte, care te va duce cu gândul la natură și la ingredientele proaspete din care este făcută această bere. Coriandrul este secretul mirosului fresh al Staropramen Unfiltered.'
},{
	icon: 'iconfont-atingere',
	title: 'atingere',
	text: 'Sticla de Staropramen Unfiltered aflată la temperatura perfectă de servire îți va surprinde până și atingerea, iar forma sticlei e perfectă pentru a ciocni o bere cu prietenii. Pentru a te bucura din plin de gustul distinct, nu uita să amesteci lichidul în sticlă înainte de servire.'
}]

$(window).on('load resize', scaleSections);

$(window).on('load', function(){
	TweenMax.to('.preloader', 0.5, {opacity:0, display:'none', ease: Power2.easeOut});
    TweenMax.fromTo(".unfiltered-cover .container", 0.5, {ease: Power2.easeOut, opacity:0, scale: 0.9, delay:1 }, {opacity:1, scale: 1});
});

animIntro = new TimelineMax({ paused: true}).timeScale(0.8)
	.to(".unfiltered-cover", 1, {ease: Power2.easeInOut, y: '-100%', onStart: function(){
		$('.unfiltered-cover').addClass('blur');
	}})
	.to(".unfiltered-bg", 0.5, {ease: Power2.easeInOut, opacity:1},'-=1')
	.set(".unfiltered-main", {className:"+=shiny"},'-=0.4')
	.fromTo(".unfiltered-main-bottles", 0.75, {ease: Power2.easeOut, opacity:0, y:'100%', x:mobileAdjust, scale: 1.25 }, {opacity:1, y: '0%', x:mobileAdjust, scale: 0.9, onStart: function(){
		setTimeout(function(){ fasSound.play(); }, 500);
	}}, '-=0.8')
	.set(".capac", {className:"+=animated"}, '-=0.25')
	.fromTo(".capac-wrapper", 0.75, {ease: Power4.easeOut, y:0, x: '-50%'}, { y: $('.capac-wrapper').offset().top, x: '-50%'}, '-=0.25')
	.fromTo(".spritz", 0.75, {ease: Power4.easeOut, scale:0.2, x: '-50%', delay: 0.75 }, { scale:1, x: '-50%'}, '-=0.75')
	.to(".spritz", 0.5, {ease: Power4.easeOut, opacity: 0, onStart: function(){
		 new TimelineMax({delay: .15})
			 .set(".capac-wrapper", {x: '-140%'})
			 .to(".capac-wrapper", 0.5, {ease: Power2.easeInOut, y: -$('.bottles-wrapper').offset().top+$(".capac-wrapper").outerHeight()/2, x: '-180%'});
	}})
	.to(".unfiltered-main-bottles", 0.6, {ease: Power2.easeOut, x:'0%', scale: 1}, '-=0.5')
	.set(".unfiltered-main", {className:"-=shiny"},'-=0.25')
	.staggerFromTo(".unfiltered-main .container-fluid p, .unfiltered-main .container-fluid hr", 0.5, {ease: Power2.easeOut, opacity:0, y:20 }, {opacity:1, y: 0}, 0.25,'-=0.3')
	.fromTo(".unfiltered-menu", 0.4, {ease: Power2.easeOut, x: '100%'}, { x: '0%'}, '-=0.25');

if (window.matchMedia("(min-width: 768px)").matches) {
	animPage[1] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-1', 1,{ease: Power2.easeOut, display:'none', opacity:1, y:'100%', x:'50%', scale: 1}, {display:'block', opacity:1, y:'10%', x:'50%', scale: 1.3})
		.to('.unfiltered-page-image-1', 0.75,{ease: Power2.easeOut, y:'0%', x:'0%', scale: 1, delay: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'})
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 50, display:'block'},'-=0.75');

	animPage[2] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-2', 0.75,{ease: Power2.easeOut, display:'none', opacity:1, x:'50%', scale: 1.3}, {display: 'block', opacity:1, x:'50%', scale: 1.3})
		.to('.unfiltered-page-image-2', 0.75,{ease: Power2.easeOut, x:'0%', scale: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 50, display:'block'},'-=0.75');

	animPage[3] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-3', 0.5,{ease: Power2.easeOut, display:'none', opacity:0, x:'50%', scale: 5}, {x:'50%', display: 'block', opacity: 1 })
		.fromTo('.unfiltered-page-image-3', 0.75,{ease: Power2.easeOut, opacity:1, x:'50%', scale: 5}, {x:'50%', scale: 1})
		.to('.unfiltered-page-image-3', 0.75,{ease: Power2.easeOut, x:'0%', scale: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 50, display:'block'},'-=0.75');

	animPage[4] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-4a', 0.75,{ease: Power2.easeOut, display:'none', opacity:1, x:'100%'}, { x:'0%', display:'block'})
		.fromTo('.unfiltered-page-image-4a', 0.75,{ease: Power2.easeOut, x:'0%'}, { x:'100%', delay:1})
		.fromTo('.unfiltered-page-image-4b', 0.75,{ease: Power4.easeOut, y:'100%', display:'none'}, { y:'0%', display:'block'})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 50, display:'block'},'-=0.75');

	animPage[5] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-5', 0.5,{ease: Power2.easeOut, display:'none', opacity:0, x:'50%', scale: 5}, {x:'50%', opacity: 1, display: 'block'})
		.fromTo('.unfiltered-page-image-5', 1,{ease: Power2.easeOut, opacity:1, x:'50%', scale: 10}, {x:'50%', scale: 1})
		.to('.unfiltered-page-image-5', 0.75,{ease: Power2.easeOut, x:'0%', scale: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 50, display:'block'},'-=0.75');
} else {
	animPage[1] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-1', 1,{ease: Power2.easeOut, display:'none', opacity:1, y:'100%', x:'0%', scale: 1}, {display:'block', opacity:1, y:'0%', x:'0%'})
		.to('.unfiltered-page-image-1', 0.75,{ease: Power2.easeOut, x:'-100%', y:'0%', scale: 1, delay: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'})
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 80, display:'block'},'-=0.75');

	animPage[2] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-2', 0.75,{ease: Power2.easeOut, display:'none', opacity:0, x:'0%', scale: 3}, {display: 'block', opacity:1, x:'0%', scale: 1})
		.to('.unfiltered-page-image-2', 0.75,{ease: Power2.easeOut, x:'-100%', scale: 1, delay: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 80, display:'block'},'-=0.75');

	animPage[3] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-3', 0.5,{ease: Power2.easeOut, display:'none', opacity:0, scale: 5}, { display: 'block', opacity: 1 })
		.fromTo('.unfiltered-page-image-3', 0.75,{ease: Power4.easeOut, scale: 5}, {scale: 1})
		.to('.unfiltered-page-image-3', 0.75,{ease: Power2.easeOut, x:'-100%', scale: 1, delay: 1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 80, display:'block'},'-=0.75');

	animPage[4] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-4a', 0.75,{ease: Power2.easeOut, display:'none', opacity:1, x:'100%'}, { x:'0%', display:'block'})
		.fromTo('.unfiltered-page-image-4a', 0.75,{ease: Power4.easeOut, y:'0%'}, { y:'100%', delay:1})
		//.fromTo('.unfiltered-page-image-4b', 0.75,{ease: Power4.easeOut, y:'100%', display:'none'}, { y:'0%', display:'block'})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 80, display:'block'},'-=0.75');

	animPage[5] = new TimelineMax({ paused: true})
		.fromTo('.unfiltered-page-image-5', 0.5,{ease: Power2.easeOut, display:'none', opacity:0, scale: 10}, {opacity: 1, display: 'block'})
		.fromTo('.unfiltered-page-image-5', 1,{ease: Power4.easeOut, scale: 10}, {scale: 1})
		.fromTo('.unfiltered-page-image-5', 0.75, {ease: Power2.easeOut, x:'0%'}, {ease: Power2.easeOut, x:'-100%', delay:1})
		.fromTo('.unfiltered-page-box', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 0, display:'block'},'-=0.25')
		.fromTo('.unfiltered-page-icon', 0.75,{ease: Power2.easeOut, opacity: 0, y:20, display:'block'},{opacity: 1, y: 80, display:'block'},'-=0.75');
}

function scaleSections() {
	if (window.matchMedia("(min-width: 768px)").matches) {
		mobileAdjust = '50%';
		iconHorizontal = '-50%';
		iconTop = $('.unfiltered-page-icon').offset().top-12;
		winH = $(window).outerHeight();
		$('.unfiltered-main, .unfiltered-page').each(function(){
			$(this).removeAttr('style').height(winH-$('.navbar.navbar-default').outerHeight()).css({'top':$('.navbar.navbar-default').outerHeight()});
		});
	} else {
		mobileAdjust = '0%';
		iconHorizontal = '0%';
		iconTop = $('.unfiltered-page-icon').offset().top-36;
		winH = $(window).outerHeight();
		if ( $("input, textarea").is(":focus") ){

		} else {
			$('.unfiltered-main, .unfiltered-page').each(function(){
				$(this).removeAttr('style').css({'padding-top':$('.navbar.navbar-default').outerHeight(),'min-height':winH});
			});
		}
	}
}

$(window).on('mousewheel swipe keypress', function(event, touch) {
	if (event.type == 'mousewheel' && event.originalEvent.wheelDelta >= 0) {
		var direction = 1;
	} else if (event.type == 'mousewheel' && event.originalEvent.wheelDelta <= 0) {
		var direction = 0;
	} else if (event.type == 'swipe' && touch.direction == 'up') {
		var direction = 0;
	} else if (event.type == 'swipe' && touch.direction == 'down') {
		var direction = 1;
	} else {
		var direction = undefined;
	}

	if (direction == 0 && !tl.isActive() ) {
		if ( cover ) {
			cover = false;
			animIntro.play();
		} else if ( currentPage ) {
			$('.unfiltered-page-back').trigger('click');
		}
	}
}).keydown(function(event) {
	if (event.keyCode == '40' && !tl.isActive() ){
		if ( cover ) {
			cover = false;
			animIntro.play();
		} else if ( currentPage ) {
			$('.unfiltered-page-back').trigger('click');
		}
	}
});

$('.iconfont-angle-double-down, .iconfont-angle-double-up').on('click', function(event, touch) {
	if (!tl.isActive() ) {
		if ( cover ) {
			cover = false;
			animIntro.play();
		} else if ( currentPage ) {
			$('.unfiltered-page-back').trigger('click');
		}
	}
});

$(document).on('ready', function () {

	$('.unfiltered-menu li').on('click', function(e){
		e.preventDefault();
		currentPage = $(this).data('page');
		changePage(currentPage);
	});

    /*$('.unfiltered-play-button').on('click', function(){
        $('#video-player').attr('src','https://www.youtube-nocookie.com/embed/'+$(this).data('video')+'?showinfo=0&autoplay=1&rel=0&controls=1');
        $('#video-overlay').fadeIn();
		if (window.ga) {
			ga('send', 'event', 'Staro 750ml','Video',$(this).data('video'));
		}
    });*/

	function changePage(page){
		$('.unfiltered-page-icon span').addClass(pages[page].icon);
		$('.unfiltered-page-icon-title').text(pages[page].title);
		$('.unfiltered-page--description').text(pages[page].text);

		$('.unfiltered-page-bg').html('<video playsinline autoplay muted loop class="unfiltered-page-video"><source src="/assets/videos/unfiltered/video'+page+(window.matchMedia("(min-width: 768px)").matches ? '' : '-mob')+'.mp4" type="video/mp4"></video>');

		if (window.matchMedia("(min-width: 768px)").matches) {
			animMain = new TimelineMax()
				.set(".unfiltered-page", {x:'0%'})
				.fromTo(".unfiltered-menu", 0.5, {ease: Power2.easeOut, x: '0%%'}, { x: '100%'}, '-=0.5')
				.staggerTo(".unfiltered-main .container-fluid p, .unfiltered-main .container-fluid hr", 0.5, {ease: Power2.easeOut, opacity:0, y: -20 }, 0.25,'-=0.3')
				.fromTo(".unfiltered-page-icon", 0.75, {ease: Power2.easeOut, scale: 1, opacity: 0, display:'none'},{scale: 3, opacity: 1, display:'block'}, '-=0.15')
				.to(".unfiltered-main-bottles", .75, {ease: Power2.easeInOut, x: '-100%', onStart:function(){
					if (page == 2) {
						//console.log('auz');
						auzSound.currentTime = 0;
						auzSound.play();
					}
				}},'-=0.5')
				.fromTo(".unfiltered-page-bg", .5, {ease: Power2.easeInOut, opacity: 0, display:'none'}, {ease: Power2.easeInOut, opacity: 1, display:'block', onStart:function(){
					//console.log('done');
					animPage[page].play();
				}})
				.fromTo(".unfiltered-page-icon", 0.5, {ease: Power2.easeOut, scale: 3, opacity: 1}, {scale: 1, opacity: 0},'-=0.5')
				.set(".unfiltered-page-icon", {top: 0});
		} else {
			animMainMobile = new TimelineMax()
				.fromTo(".unfiltered-menu", 0.5, {ease: Power2.easeOut, x: '0%'},{x: '100%'})
				.to(".unfiltered-main-bottles", .75, {ease: Power2.easeInOut, x: '-100%'},'-=0.25')
				.set(".unfiltered-page", {x:'0%'})
				//.set(".unfiltered-page-icon", {y:'-50%'})
				.fromTo(".unfiltered-page-icon", 0.75, {ease: Power2.easeOut, scale: 1, y:'-50%', opacity: 0, display:'none'},{scale: 2, y:'-50%', opacity: 1, display:'block', onStart:function(){
					if (page == 2) {
						//console.log('auz');
						auzSound.currentTime = 0;
						auzSound.play();
					}
				}}, '-=0.15')
				.fromTo(".unfiltered-page-bg", .5, {ease: Power2.easeInOut, opacity: 0, display:'none'}, {ease: Power2.easeInOut, opacity: 1, display:'block', onStart:function(){
					//console.log('done');
					animPage[page].play();
				}})
				.fromTo(".unfiltered-page-icon", 0.5, {ease: Power2.easeOut, scale: 2, opacity: 1, y:'-50%'}, {scale: 1, opacity: 0, y:'-50%'},'-=0.5')
				.set(".unfiltered-page-icon", {top: 0})
				.fromTo(".unfiltered-page-scroll", 0.5, {ease: Power2.easeOut, opacity: 0, y:20}, { opacity: 1, display:'block', y:0},'+=3');
		}
	}

	$('.unfiltered-page-back').on('click', function(e){
		e.preventDefault();
		new TimelineMax()
			.to(".unfiltered-page", 0.5, {ease: Power2.easeOut, scale: 0.8})
			.to(".unfiltered-page", 0.5, {ease: Power2.easeOut, x: '100%', onComplete:function(){
				$('.unfiltered-page-bg').html('');
				$('.unfiltered-page-icon, .unfiltered-page-bg').removeAttr('style');
				$('.unfiltered-page-icon span').attr('class','');
				animPage[1].pause(0);
				animPage[2].pause(0);
				animPage[3].pause(0);
				animPage[4].pause(0);
				animPage[5].pause(0);
			}},'-=0.15')
			.set(".unfiltered-page", {scale: 1})
			.set(".unfiltered-page-box", {opacity: 0})
			.set(".unfiltered-page-icon", {x: '0%'})
			.to(".unfiltered-main-bottles", .75, {ease: Power2.easeInOut, x: '0%'},'-=0.5')
			.staggerTo(".unfiltered-main .container-fluid p, .unfiltered-main .container-fluid hr", 0.5, {ease: Power2.easeOut, opacity:1, y: 0 }, 0.25,'-=0.3')
			.to(".unfiltered-menu", 0.5, {ease: Power2.easeOut, x: '0%'}, '-=0.5');
		currentPage = null;
	});

	$('#participa').on('click', function(){

	});


	$('#participa').on('click', function(){
		(window.dataLayer || []).push({ 'event': 'lta-open-form' });
	});

    $('#video-close').on('click', function(){
        $('#video-player').attr('src','');
        $('#video-overlay').fadeOut();
    });

	$('#mesaj').on('keyup', function(){
		$('#counter').text('Mai ai '+(160-$('#mesaj').val().length)+' caractere');
	});

	var formRegister = new AjaxPostman(
			'form.unfiltered-form',
			function() {
				(window.dataLayer || []).push({ 'event': 'lta-success' });
				if (window.ga) {
					ga('send', 'pageview', '/la-tine-acasa/success');
					//ga('send', 'event', 'Staro 750ml','Register','Success');
				}
				$("form.unfiltered-form").slideUp();
				$(".unfiltered-confirmation").slideDown();
			}
	);

});
